import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Unit } from '../state-man/models/unit.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class UnitService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the units already held, or '' for none.
  // rows is null when those are still current.
  public async getAll (version: string) : Promise<{ version: string, rows: Unit[] | null } | null> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'unit/active/', { version })
      if (Array.isArray(ret)) return { version: '', rows: Unit.buildMany(ret) }
      if (ret?.unchanged) return { version: ret.version, rows: null }
      return Array.isArray(ret?.rows) ? { version: ret.version, rows: Unit.buildMany(ret.rows) } : null
    } 
    catch (error) {     
      LoggerService.log(error + 'unit/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
  }  
  
}
